// React
import { useMemo } from "react";
// MUI
import { Skeleton, Stack } from "@mui/material";

//  Components
import SeverityBarIndicatorSkeleton from "./SeverityBarIndicatorSkeleton";

// Component for a single graph skeleton with random bar heights
interface GraphSkeletonProps {
	barCount?: number;
	minHeight?: number;
	maxHeight?: number;
}

function generateRandomBarHeights(count: number, minHeight: number = 60, maxHeight: number = 300): number[] {
	return Array.from({ length: count }, () => Math.floor(Math.random() * (maxHeight - minHeight + 1)) + minHeight);
}

function GroupedBarChartSkeleton({ barCount = 9, minHeight = 60, maxHeight = 300 }: GraphSkeletonProps) {
	// Generate random heights once per render using useMemo
	const barHeights = useMemo(() => generateRandomBarHeights(barCount, minHeight, maxHeight), [barCount, minHeight, maxHeight]);

	return (
		<Stack spacing={2}>
			<Skeleton variant="text" width={300} height={40} />
			<Stack direction={"row"} justifyContent={"space-between"} spacing={0.5} height={maxHeight}>
				{barHeights.map((height, index) => (
					<Skeleton
						key={index}
						variant="rectangular"
						height={height}
						width={60}
						className="rounded-md"
						sx={{ alignSelf: "flex-end" }}
					/>
				))}
			</Stack>
		</Stack>
	);
}

type MultiGroupedBarChartAnalyticsSkeletonProps = {
	showSeverityBar?: boolean;
};
export default function MultiGroupedBarChartAnalyticsSkeleton(props: MultiGroupedBarChartAnalyticsSkeletonProps) {
	const { showSeverityBar = true } = props;
	return (
		<Stack component={"section"} id={"f&i-all-deals-analytics-"} pt={4} pb={6.5} spacing={4} justifyContent={"space-between"}>
			<Skeleton variant="text" width={700} height={50} />
			<Stack direction={"row"} justifyContent={"space-between"} spacing={10} alignSelf={"center"}>
				<GroupedBarChartSkeleton barCount={9} minHeight={60} maxHeight={300} />
				<GroupedBarChartSkeleton barCount={9} minHeight={50} maxHeight={300} />
			</Stack>
			{showSeverityBar && <SeverityBarIndicatorSkeleton />}
		</Stack>
	);
}
